const appConfig = {
    appId: import.meta.env.VITE_APP_ID,
    appCluster: import.meta.env.VITE_APP_CLUSTER,
    databaseName: import.meta.env.VITE_DB_NAME,
    databaseColl: {
        routes: import.meta.env.VITE_DB_ROUTES,
        chats: import.meta.env.VITE_DB_CHATS,
        chatMessages: import.meta.env.VITE_DB_CHAT_MESSAGES,
        chatImages: import.meta.env.VITE_DB_CHAT_IMAGES,
    },
    databaseCollWatch: import.meta.env.VITE_DB_WATCH,
    databaseConnString: import.meta.env.VITE_DB_CONN,
    databaseChatsView: import.meta.env.VITE_DB_MESSAGES_VIEW,
    databaseShipmentsView: import.meta.env.VITE_DB_SHIPMENT_VIEW,

    serverChatBaseURL: import.meta.env.VITE_SERVER_URL,
    socketChatBaseURL: import.meta.env.VITE_SOCKET_URL,

    localChatSocketURL: import.meta.env.VITE_LOCAL_CHAT_SOCKET_URL,
    localChatServerURL: import.meta.env.VITE_LOCAL_CHAT_SERVER_URL,

    baseurl: import.meta.env.VITE_BASE_URL,
};

export { appConfig };
